import { showToast } from "@sourcewhale/shared/src/assets/js/src/general/utils";
import { derived, writable } from "svelte/store";
import { queryCompanies } from "../../../../../api/companies";
import {
  activePopUpModalStore,
  editContactStore,
  showEditContact,
} from "../../stores";

export const invalidItemStore = writable({});

const typeMap = {
  email: "email",
  phone: "phone",
  URL: "socialLink",
};

export const handleInvalidItem = (message) => {
  const match = message.match(/Invalid (.*): (.+)/);
  if (match) {
    const type = typeMap[match[1]];
    invalidItemStore.set({ type, value: match[2], message });
  }
  showToast({
    title: "An error occurred",
    subtitle: message,
    type: "danger",
  });
};

export const helperTextStore = derived(
  invalidItemStore,
  ($invalidItemStore) => {
    const { type, message } = $invalidItemStore;
    return type ? { [`${type}s`]: `${message}` } : {};
  },
);

export const confirmDirty = () => {
  activePopUpModalStore.set({
    modal: "confirmNavigation",
    confirm: () => {
      activePopUpModalStore.set(null);
      showEditContact.set(false);
      showToast({
        title: "Success!",
        subtitle: "Discarded unsaved changes.",
        type: "success",
      });
    },
    cancel: () => {
      activePopUpModalStore.set(null);
    },
  });
};

export const selectedCompanyStore = writable({
  companyId: null,
  name: "",
  logo: null,
});

// Derive edited state from comparing values instead of tracking manually
export const hasEditedCompanyStore = derived(
  [selectedCompanyStore, editContactStore],
  ([$selectedCompany, $editContactStore]) =>
    $selectedCompany.companyId &&
    $selectedCompany.name !== $editContactStore.company,
);

export const fetchCompanySuggestions = async (name) => {
  const response = await queryCompanies({
    draw: 1,
    columns: [
      {
        data: "name",
        name: "",
        searchable: true,
        orderable: true,
        search: { value: "", regex: false, fixed: [] },
      },
      {
        data: "employeeCount",
        name: "",
        searchable: true,
        orderable: true,
        search: { value: "", regex: false, fixed: [] },
      },
      {
        data: "industries",
        name: "",
        searchable: true,
        orderable: true,
        search: { value: "", regex: false, fixed: [] },
      },
      {
        data: "headquarters",
        name: "",
        searchable: true,
        orderable: true,
        search: { value: "", regex: false, fixed: [] },
      },
      {
        data: "updatedAt",
        name: "",
        searchable: true,
        orderable: true,
        search: { value: "", regex: false, fixed: [] },
      },
    ],
    order: [{ column: 0, dir: "asc", name: "" }],
    start: 0,
    length: 10,
    search: { value: name, regex: false, fixed: [] },
  });

  return response?.data?.length
    ? response.data.map((company) => ({
        label: company.name,
        value: company.companyId,
        data: company,
      }))
    : [];
};

export const handleCompanySelect = (suggestion) => {
  // Update both stores in sync to ensure derived state works correctly
  // First update the company name in the edit contact store
  editContactStore.update((store) => ({
    ...store,
    company: suggestion.label,
  }));

  // Then update the company details in the selection store
  selectedCompanyStore.set({
    companyId: suggestion.data.companyId,
    name: suggestion.label,
    logo: suggestion.data.logo || null,
  });
};

// We can't directly set derived stores, so we reset the selectedCompanyStore instead
export const resetCompanyState = () => {
  // Reset by setting the values in selectedCompanyStore to their initial state
  selectedCompanyStore.set({
    companyId: null,
    name: "",
    logo: null,
  });
};
